@use 'src/global/variables.scss' as var;

:host(.hide-chatbot) {
  // Have to use visibility hidden instead of display block or hidden attribute, because of Mac's VoiceOver
  // Screen Reader, which does not move focus into the dialog otherwise.
  visibility: hidden !important;
}

:host {
  z-index: 100002; // One higher than regular bot in case both are opened on same page
  flex-direction: column;
  display: flex;
  // The same background as the header is needed for IE11,
  // where there is a small gap between the header and the ba-chatbot-welcome/message-screen,
  // in which the background color below will shine through, resulting in a white line
  // if we don't set it here. Setting the background-color here, then leads to an issue on Safari, where the
  // background-color shines through around the input element at the bottom of the chatbot,
  // so we need to set the white background-color there
  background-color: var.$ls-primary-color;

  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 1.5;

  hyphens: none;
  word-break: normal;
  overflow-wrap: break-word;

  // To display the bot in full screen, 100vh does not work because of iPhones and the fix suggested here is not working either:
  // https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
  // https://css-tricks.com/css-fix-for-100vh-in-mobile-webkit/
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: auto;
  height: auto;
  border-radius: 0;

  // Todo
  // - Use bold instead of cursive text -> 1) Change <em> -> <strong> in backend 2) Or replace in frontend
}
